import { render, staticRenderFns } from "./RiskModelGroupItem.vue?vue&type=template&id=1ba36f86&scoped=true&"
import script from "./RiskModelGroupItem.vue?vue&type=script&lang=js&"
export * from "./RiskModelGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba36f86",
  null
  
)

export default component.exports